import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BankcardTicketsService } from './bankcard-tickets.service';

import { BankcardTicketsActions } from './+state/bankcard-tickets.actions';
import { BankcardTicketsEpics } from './+state/bankcard-tickets.epic';
import { BankcardTicketsFacade } from './+state/bankcard-tickets.facade';


@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [BankcardTicketsService, BankcardTicketsActions, BankcardTicketsFacade, BankcardTicketsEpics]
})
export class BankcardTicketsModule {}
